<!-- <ab-table [header]="rendering.fields" [data]="accountsOverview" [cols]="['col-xs-2', 'col-xs-2']"></ab-table> -->

<!-- ngRepeat: portfolio in Accounts -->
<section data-ng-repeat="portfolio in Accounts" class="ao-block ng-scope">
  <header class="ao-header">
    <div class="row">
      <div class="col-sm-7">
        <h2 class="ao-header-title text-overflow">
          <i class="icon-single ng-hide" data-ng-show="portfolio.IsSingle"></i>
          <i class="icon-joint ng-hide" data-ng-show="portfolio.IsJoint"></i>
          <i class="icon-corporate" data-ng-show="portfolio.IsCorporate"></i>
          <span class="ng-binding">Marie Kreutz A/O Jason Bourne Res</span>
        </h2>
      </div>
      <!-- ngIf: !portfolio.IsCreditCard -->
      <div
        class="col-sm-5 actions-group ng-scope"
        data-ng-if="!portfolio.IsCreditCard"
      >
        <button
          class="btn btn-sm btn-white btn-sm-rotate"
          data-ng-click="open(portfolio)"
        >
          <i
            class="icon-settings"
            data-ng-class="{'icon-rotate' : isLoading.savePrefs}"
          ></i>
        </button>
      </div>
      <!-- end ngIf: !portfolio.IsCreditCard -->
    </div>
  </header>
  <div class="table-responsive">
    <table class="table table-striped ao-table">
      <colgroup>
        <col class="col-md-2 col-sm-2" />
        <col class="col-md-4 col-sm-4" />
        <col class="col-md-1" />
        <col class="col-md-2" />
        <col class="col-md-2" />
        <col class="col-md-1" />
      </colgroup>
      <thead>
        <tr>
          <th>Account Number</th>
          <th>Account Name</th>
          <th class="text-center">Currency</th>
          <th class="text-right">
            Balance
            <i
              class="fa fa-info-circle ng-scope"
              data-popover-trigger="mouseenter"
              data-popover-placement="bottom"
              data-popover="The Balance is the sum of all debits and credits of an account. It includes all funds which are cleared and not cleared. The Balance does not include overdraft facilities and amounts on hold."
            ></i>
          </th>
          <th class="text-right">
            Available Balance
            <i
              class="fa fa-info-circle ng-scope"
              data-popover-trigger="mouseenter"
              data-popover-placement="bottom"
              popover-append-to-body="true"
              data-popover="The Available Balance is the amount available for you to withdraw or transfer, in addition to overdraft facilities. It includes all cleared funds, such as: credit or debit transactions, amounts on hold, cash deposits, card purchases, cleared checks. The Available Balance does not include overdraft facilities and amounts with a future value date (i.e. future transfers, checks)."
            ></i>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <!-- ngRepeat: product in portfolio.Products --><!-- ngIf: product.Visible -->
        <tr
          data-ng-repeat="product in portfolio.Products"
          data-ng-if="product.Visible"
          class="ng-scope"
        >
          <!-- ngIf: product.IsLinkActive == false -->
          <!-- ngIf: product.IsLinkActive == true -->
          <td data-ng-if="product.IsLinkActive == true" class="ng-scope">
            <a
              href="payments/transactions/overview?id=OUloSUx1STNiQmNsQTE1QlhHRjgxUGxYZGxjbnV1U0U=YVMxUGVqVGc0T1FRMWZtNDJXT20zQT09"
              class="ng-binding"
              >22220001</a
            >
          </td>
          <!-- end ngIf: product.IsLinkActive == true -->
          <!-- ngIf: product.Status != 'open' -->
          <!-- ngIf: product.Status == 'open' -->
          <td ng-if="product.Status == 'open'" class="ng-binding ng-scope">
            SAVINGS USD
          </td>
          <!-- end ngIf: product.Status == 'open' -->
          <td class="text-center ng-binding">USD</td>
          <td class="text-right ng-binding">1,200.00</td>
          <td class="text-right ng-binding">1,100.00</td>
          <td class="text-right">
            <div class="btn-group dropup drop-up" dropdown="">
              <button
                type="button"
                data-ng-disabled="false"
                class="btn btn-md dropdown-toggle btn-icon-square btn-danger"
                data-toggle="dropdown"
                data-ng-class="product.AccountActions == null ? 'btn-gray' : 'btn-danger'"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  data-ng-class="product.Status == 'blocked' ? 'icon-locker' : (product.Status == 'closed' || product.Status == 'pending_closure' ? 'icon-block' : 'icon-equal-sign')"
                  class="icon-equal-sign"
                ></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-right" role="menu">
                <!-- ngRepeat: action in product.AccountActions -->
                <li
                  data-ng-repeat="action in product.AccountActions"
                  class="ng-scope"
                >
                  <a
                    ng-click="openUrl(portfolio.Id, action.Url)"
                    class="btn btn-link btn-lg ng-binding"
                    >Internal Transfer</a
                  >
                </li>
                <!-- end ngRepeat: action in product.AccountActions -->
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
<!-- end ngRepeat: portfolio in Accounts -->
